"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _accountMenu = _interopRequireDefault(require("./account-menu"));

var _pill = _interopRequireDefault(require("../pill"));

var _navModule = _interopRequireDefault(require("./nav.module.scss"));

var Navigation = function Navigation(_ref) {
  var _ref$cartItemCount = _ref.cartItemCount,
      cartItemCount = _ref$cartItemCount === void 0 ? 0 : _ref$cartItemCount,
      CartLink = _ref.cartLink,
      accountLink = _ref.accountLink,
      _ref$accountMenuItems = _ref.accountMenuItems,
      accountMenuItems = _ref$accountMenuItems === void 0 ? [] : _ref$accountMenuItems,
      displayAccount = _ref.displayAccount;
  var displayAccountMenu = accountMenuItems.length > 0;
  var cartLinkIsString = typeof CartLink === 'string'; // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid

  var CartLinkElement = cartLinkIsString ? /*#__PURE__*/_react.default.createElement("a", null) : CartLink;
  var cartLinkProps = cartLinkIsString ? {
    href: CartLink
  } : {};
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _navModule.default.container
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: _navModule.default.nav
  }, /*#__PURE__*/_react.default.cloneElement(CartLinkElement, cartLinkProps, /*#__PURE__*/_react.default.createElement("section", {
    "aria-label": "".concat(cartItemCount, " items in your cart")
  }, "Cart", cartItemCount > 0 && /*#__PURE__*/_react.default.createElement(_pill.default, {
    className: _navModule.default.cartItems
  }, cartItemCount))), displayAccount && (displayAccountMenu ? /*#__PURE__*/_react.default.createElement(_accountMenu.default, {
    items: accountMenuItems
  }) : /*#__PURE__*/_react.default.createElement("a", {
    href: accountLink
  }, "Account"))));
};

Navigation.defaultProps = {
  displayAccount: false
};
Navigation.propTypes = {
  cartItemCount: _propTypes.default.number,
  cartLink: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  accountLink: _propTypes.default.string,
  accountMenuItems: _propTypes.default.array,
  displayAccount: _propTypes.default.bool
};
var _default = Navigation;
exports.default = _default;